module.exports = __webpack_public_path__ + "static/media/cubaflag.1d679c83.png";